'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.years;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/years.js
// module id = 761
// module chunks = 0